export default "__VITE_ASSET__BeBg8eXy__"